import { isPast } from "date-fns";

export type TokenResource = {
  accessToken: string;
  refreshToken: string;
  refreshTokenExpires: Date;
};

/*
 * Save token data in local storage.
 */
export function saveTokenResource(resource: TokenResource): void {
  if (window) {
    console.log("Save Token");
    window.localStorage.setItem("AT", resource.accessToken);
    window.localStorage.setItem("RT", resource.refreshToken);
    window.localStorage.setItem("RTE", resource.refreshTokenExpires.toString());
  }
}

export type LoadedTokenResource = {
  accessToken: string;
  refreshToken: string;
  refreshTokenExpires: Date;
};

/*
 * Fetch token data from local storage.
 */
export function loadTokenResource(): null | LoadedTokenResource {
  try {
    const accessToken = window.localStorage.getItem("AT");
    const refreshToken = window.localStorage.getItem("RT");
    const expiry = window.localStorage.getItem("RTE");

    // If anything's missing, abort.
    if (accessToken == null || refreshToken == null || expiry == null)
      throw new Error();

    const refreshTokenExpires = new Date(expiry);

    if (isPast(refreshTokenExpires)) throw new Error();

    return { accessToken, refreshToken, refreshTokenExpires };
  } catch (_error) {
    return null;
  }
}
